export default function QuoteTitle({ children }) {
  return (
    <div className='flex w-full'>
      <div className='relative inline-block mx-auto text-center my-14'>
        <Quote className='absolute top-[-20px] left-[-8px]'/>
        <div className='text-[22px] leading-8 font-bold tracking-[0.2em]'>{ children }</div>
        <Quote className='rotate-180 absolute bottom-[-20px] right-[-8px]'/>
      </div>
    </div>
  )
}

const Quote = ({ className }) => <div className={ cn('w-5', className) }>
  <C.Image src={ cdn('next/join-us/up.png') } className='w-full aspect-1'/>
</div>